module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"Select an option you prefer","option1":"Go to Court Administration Office","option2":"Connect to live assistance"},"es":{"header":"Selecciona una opción que prefieras","option1":"Ir a la Secretaría del Tribunal","option2":"Conéctese a la asistencia en vivo"}}')
  delete Component.options._Ctor
}
